<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col col-md-8  col-lg-6">
        <div class="page-header">
          <h1>Reset Password</h1>
        </div>
      </div>
    </div>

    <div id="content">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col col-md-8  col-lg-6">
            <ShowErrors
              :errorMessages="errorMessages"
            />
            <p>
              Please enter the reset password token that you received in your inbox below and
              set the new password for your Ninkashi account
            </p>

            <form>
              <div class="form-group">
                <label for="token">Reset Password Token</label>
                <input type="text" name="token" class="form-control form-control-lg"
                      v-model="user.token" v-validate="'required'">
                <span v-show="errors.has('token')" class="input-error">
                  {{ errors.first('token') }}
                </span>
              </div>

              <div class="form-group">
                <label for="password">New Password</label>
                <input type="password" v-model="user.password" name="password" class="form-control form-control-lg"
                      v-validate="'required|min:8'" ref="password" />
                <span v-show="errors.has('password')" class="input-error">{{ errors.first('password') }}</span>
              </div>

              <div class="form-group">
                <label for="password">Confirm New Password</label>
                <input type="password" name="passwordConfirmation" v-validate="'required|confirmed:password'"
                      data-vv-as="password" class="form-control form-control-lg" />
                <span v-show="errors.has('passwordConfirmation')" class="input-error">{{ errors.first('passwordConfirmation') }}</span>
              </div>

              <button type="button" class="btn btn-primary btn-lg" v-on:click="validate()">
                Reset Password
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowErrors from '../common/ShowErrors'

export default {
  name: 'ResetPassword',
  components: {
    ShowErrors
  },
  data: function () {
    return {
      user: {
        token: null,
        password: null
      },
      errorMessages: []
    }
  },
  methods: {
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.resetPassword()
        }
      })
    },
    resetPassword () {
      var self = this

      this.$http.post('passwords/reset', { token: this.user.token, password: this.user.password }).then(function (response) {
        self.errorMessages = []

        self.$swal({
          title: 'Password updated!',
          type: 'success'
        })

        self.$router.push('/users/profile/my-profile')
      }).catch(function (error) {
        self.errorMessages = []

        if (error) {
          var errorMsg = error.response.data.message || error.response.data.error
          self.errorMessages.push(errorMsg)
        }
      })
    }
  }
}
</script>
